<template>
  <v-banner
    v-if="show"
    app
    :icon="icons.mdiAlertCircleOutline"
    icon-color="red"
    class="mb-4 warning-banner"
    outlined
    >
    <mrx-translation :token="token"></mrx-translation>
  </v-banner>
</template>

<script>
  import { mapGetters } from 'vuex'
  import icons from '@/mixins/icons'

  export default {
    mixins: [icons],
    name: 'warning',
    computed: {
      token() {
        switch (this.engagementStatus) {
          case 'demo':
            return 'app.warning.demo_mode'
          case 'training':
            return 'app.warning.training_mode'
          default:
            return null
        }
      },
      show() {
        return this.token !== null
      },
      ...mapGetters({
        engagementStatus: 'v4/settings/status',
      })
    },
  }
</script>

<style scoped>
</style>
